import React from 'react';

const IconShare = ({
  color = '#2E93EE',
  size = 24,
  testId = 'icon-share',
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={testId}>
    <path d="M10.5004 11.9998H5.00043M4.91577 12.2913L2.58085 19.266C2.39742 19.814 2.3057 20.0879 2.37152 20.2567C2.42868 20.4032 2.55144 20.5143 2.70292 20.5565C2.87736 20.6052 3.14083 20.4867 3.66776 20.2495L20.3792 12.7294C20.8936 12.4979 21.1507 12.3822 21.2302 12.2214C21.2993 12.0818 21.2993 11.9179 21.2302 11.7782C21.1507 11.6175 20.8936 11.5017 20.3792 11.2703L3.66193 3.74752C3.13659 3.51111 2.87392 3.39291 2.69966 3.4414C2.54832 3.48351 2.42556 3.5943 2.36821 3.74054C2.30216 3.90893 2.3929 4.18231 2.57437 4.72907L4.91642 11.7854C4.94759 11.8793 4.96317 11.9262 4.96933 11.9742C4.97479 12.0169 4.97473 12.06 4.96916 12.1026C4.96289 12.1506 4.94718 12.1975 4.91577 12.2913Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default IconShare;
